import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class SeniorityReportController {
  constructor($rootScope, $uibModal, $state, $http) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.queryResult;
    this.$rootScope = $rootScope;
    this.formatCurrency = formatCurrency;

    let self = this;


    self.queryParams = {

    };

    this.$http.post(this.$rootScope.apiHost+"/api/reports/seniorityreport", this.queryParams, {withCredentials: true}).then(function (success) {
      self.queryResult = success.data;
    });


  }


  search() {
    let self = this;

    this.$http.post(this.$rootScope.apiHost+"/api/reports/seniorityreport", this.queryParams, {withCredentials: true}).then(function (success) {
      self.queryResult = success.data;
    });
  }




}

export default SeniorityReportController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/seniority-report/seniority-report.controller.js